import { useStore } from "vuex";
import { isDefined } from "@utils/var.check";
import { computed, watch } from "vue";
import { useToast } from "@/plugins/toast/composables/toast-instance";
import { useI18n } from "vue-i18n";

interface Error {
  title: string;
  subTitle: string;
  hasTimeout: boolean;
  id: string;
}

export function useErrorBanner() {
  const store = useStore();
  const toast = useToast();
  const { t } = useI18n();

  const getListOfError = computed(() => store.getters["app/getListOfError"]);

  const removeError = (id: string) => store.dispatch("app/removeError", id);
  const setErrorsDisplayed = (ids: string[]) => store.dispatch("app/setErrorsDisplayed", ids);
  const removeTimeoutError = () => store.dispatch("app/removeTimeoutError");

  watch(
    getListOfError,
    async (errors: Error[]) => {
      const errorIds: string[] = [];
      if (errors.length === 0) {
        return;
      }
      errors.forEach((error) => {
        toast.show("error", {
          title: error.title ? error.title : t("api_fetch_generic_error_message"),
          subTitle: error.subTitle ? error.subTitle : "",
          hasTimeout: isDefined(error.hasTimeout) ? error.hasTimeout : true,
          actionClose: () => {
            if (error.id) {
              removeError(error.id);
            }
          },
        });
        errorIds.push(error.id);
      });
      await setErrorsDisplayed(errorIds);
      await removeTimeoutError();
    },
    {
      deep: true,
    },
  );

  return {
    removeError,
    setErrorsDisplayed,
    removeTimeoutError,
  };
}
